import React from 'react';
import { connect } from 'react-redux';
import { setAuthProperty } from '../js/actions/index';
import { Modal, Table, Button, Alert } from "react-bootstrap";
import { XCircle } from 'react-bootstrap-icons';
import { withRouter } from "react-router-dom";

import moment from 'moment';
import 'moment-timezone';

import AlertErrorComponent from './AlertErrorComponent';
import AlertSuccessComponent from './AlertSuccessComponent';

import {EASYSOFT, ECOUNT, MULTIABLE, INVOICE, UI} from '../constants/GlobalConstant';

import I18N from "../js/i18n";

import {DELIVERY_LINES} from '../constants/DeliveryLines';

const axios = require('axios').default;

const PUSH = "push";
const PUSHED = "pushed";
const MULTIABLE_ERROR_SESSION = "accessToken";

function mapDispatchToProps(dispatch) {
  return {
    setAuthProperty: payload => dispatch(setAuthProperty(payload))
  };
}

class PurchaseOrderERPComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading:false,
      authError:"",
      errorMessage:"",
      data:[],
      dataPOI:[],
      session:'',
      isSubmit:false,
      isSubmitSuccess:false,
      products:[],
      invoiceUnits:[],
      poId:0,
      branchId:0,
      invoiceId:0
    }
  }

  componentDidMount = async () => {
    if(!this.props.auth.erp.pushDate) {
      switch(this.props.auth.erp.platform) {
        case MULTIABLE: {
          if((this.props.data && this.props.data.length) || this.props.mode === "delete" || this.props.mode === "search" || this.props.mode === "transferLine") {
            console.log("DELIVERY LINE FOR M18: ", this.props.deliveryLine)
            let sessionConsole = await this.getSessionConsole();

            let session = this.handleSessionConsole(sessionConsole, {
              putERPSessionId:true
            });

            if(session) {
              this.handleGetSessionAPIResponse({
                data : {
                  access_token:session
                }
              }, {
                putERPSessionId:false
              });
            }
          }
          break;          
        }
        case EASYSOFT: {
          this.doSubmit();
          break;
        }
        default: {
          console.err("Error: ERP Platform not set")
        }
      }
    }
  }

  componentDidUpdate = () => {
  }

/*
API
*/

// Error Handling

  handleError = (err) => {
    if(err) {
      console.error(err);
    }
    this.setState({
      isSubmit:false,
      isSubmitSuccess:false,
      errorMessage:"Internal Server Error (500)"
    });
    if(typeof this.props.onError === 'function') {
      this.props.onError();
    }
  }

// Success Handling

  handleSuccess = (data) => {
    if(this.props.visible) {
      this.setState({
        authError:'',
        errorMessage:'',
        isSubmit:false,
        isSubmitSuccess:true
      });
    }
    if(typeof this.props.onSuccess === 'function') {
      this.props.onSuccess(data);
    }
  }

// Catch Handling

handleCatch = (err) => {
  //console.log('response:',err.response);
  if(err.response && err.response.data && err.response.data.info && (err.response.data.info.indexOf(MULTIABLE_ERROR_SESSION) > -1)) {
    this.getSessionAPI({
      putERPSessionId:true
    });
  } else {
    this.handleError(err);
  }
}


// Session

  getSessionConfig = () => {
    switch(this.props.auth.erp.platform) {
      case "ECOUNT": {
        return {
          "COM_CODE": "902590",
          "USER_ID": "ADMIN",
          "API_CERT_KEY": "",
          "LAN_TYPE": "en-US",
          "ZONE": "ia"
        }
      }
      case "MULTIABLE": {
        return {
          "client_id":"MDQ0N2Y4YzctNzJlOC00NDM4LWFkYmYtZGFjNTdjZDE5NDVk",
          "client_secret":"",
          "username":"horus",
          "password":"",
          "grant_type":"password"
         }        
      }
      default: {
        // error
        this.handleError();
      }
    }
  }

  handleGetSessionAPIResponse = async (res, config) => {
    console.log('handle session');
    switch(this.props.auth.erp.platform) {
      case ECOUNT: {
        if(Object.keys(res.data.Data.Datas).length === 0) {
          this.setState({
            isLoading:false,
            errorMessage:res.data.Data.Message
          });
        } else {
          if(this.props.auth.mode === "restuarant") {
            try {
              await this.putBusinessSessionId(res.data.Data.Datas.SESSION_ID);
              this.setState({
                isLoading:false,
                session:res.data.Data.Datas.SESSION_ID
              }, () => {
                if(config && config.doSubmit) {
                  this.doSubmit();
                }
              });
            } catch (err) {
              this.handleError(err);
            }
          }
        }
        /*
        let value = this.props.auth.erp;
        value.sessionId = this.state.session;
        this.props.setAuthProperty({
          "prop":"erp",
          "value":value
        }).then(() => {
          if(this.props.auth.mode === "restuarant") {
            this.putBusinessSessionId(this.state.session);
          }
        });
        */

        break;
      }
      case MULTIABLE: {
        if(res.data.access_token) {
          try {
            
            if(config.putERPSessionId) {
              await this.putERPSessionId(res.data.access_token);
            }

            this.setState({
              session:res.data.access_token
            }, () => {
              if(!this.props.visible) {
                if(this.props.mode === "push") {
                  this.handleSubmit();
                } else if(this.props.mode === "delete") {
                  if(this.props.auth.erp.mode !== INVOICE) {
                    this.handleDeleteSales();
                  } else {
                    this.handleDeleteInvoice();
                  }
                } else if(this.props.mode === "search") {
                    this.handleSearch();
                } else if(this.props.mode === "transferLine") {
                  this.handleTransferLine();
                }
              }
            });
          } catch (err) {
            this.handleError(err);
          }
        } else {
          this.setState({
            errorMessage:res.data.Data.Message
          });
        }
        break;
      }
      default: {
        // error
        this.handleError();
      }
    }
  }

  getSessionAPI = (config) => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/erp/session`, 
    {
      params:{
        erp:this.props.auth.erp.platform,
        api:this.props.auth.erp.api.session,
        config:this.getSessionConfig()
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
    .then( (response) => {
      this.handleGetSessionAPIResponse(response.data, config);
    })
    .catch( (err) => {
      // error
      this.handleError(err);
    });
  }

// Get Session Console

  getSessionConsole = () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/session/console`, 
    {
      params:{
        mode:this.props.auth.mode,
        id:this.props.auth.businessId ? this.props.auth.businessId : this.props.auth.supplierId
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
    .then( (response) => {
      return response.data.data;
    })
    .catch( (err) => {
        // error
        this.handleError(err);
    }); 
  }

/*
Handle Search
*/

  handleSearch = async () => {
    const sessionConfig = this.getSessionConfig();
    const head = {
      'client_id':sessionConfig.client_id,
      'authorization':`Bearer ${this.state.session}`
    };

    try {
      let response = await this.getSearchAPI(head);
      this.handleSuccess(response);
    } catch (err) {
      this.handleCatch(err);
      return;
    }
  }

// (GET) Search
  getSearchAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/search`, {
      params:{
        api: this.props.auth.erp.api.get.search,
        headers:JSON.stringify(head),
        params:JSON.stringify(this.props.params)
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    });
  }

// Handle Session Console

  handleSessionConsole = (sessionConsole, config) => {
    let expire = moment(moment(sessionConsole.ERPSessionExpiry).utc().format('YYYY-MM-DD HH:mm:ss')) < moment();
    if( expire ||  !sessionConsole.ERPSessionExpiry) {
      console.log('session expired');
      this.getSessionAPI(config);
      return;
    } else {
      console.log('existing session');
      return sessionConsole.ERPSessionId;
    }
  }


/*
Invoice
*/

// Invoice
  getInvoiceAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/invoice`, {
      params:{
        api: this.props.auth.erp.api.get.invoice,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          menuCode: 'siso',
          id:this.state.invoiceId
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    });
  }

// Invoice Id
  getInvoiceIdAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/invoice/id`, {
      params:{
        api: this.props.auth.erp.api.get.invoiceId,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          resultFields: 'udfhorussono',
          stSearch: 'siso',
          conds: `udfhorussono=equal=${this.props.orderName}`
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
  }

  postInvoiceAPI = (params, data) => {
    var formData = new FormData(); 
    formData.append('file', JSON.stringify(data));
    return axios({
        method: 'post',
        //url: `${process.env.REACT_APP_API_URL}/api/erp/invoice`,
        url: `${process.env.REACT_APP_API_URL}/api/erp/invoice`,
        data: formData,
        headers: {
            Authorization: 'Basic ' + this.props.auth.token,
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        },
        params:params
    });
  }

  deleteInvoiceAPI = (params) => {
    return axios.delete(`${process.env.REACT_APP_API_URL}/api/erp/invoice`,{
      headers: {
          Authorization: 'Basic ' + this.props.auth.token
      },
      params:params
    });
  }

/*
Sales
*/

// Sales PO
  getPOAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/po`, {
      params:{
        api: this.props.auth.erp.api.get.purchaseOrder,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          menuCode: 'oldso',
          id:this.state.poId
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    });
  }

// Sales POId
  getPOIdAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/po/id`, {
      params:{
        api: this.props.auth.erp.api.get.purchaseOrderId,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          menuCode: 'oldso',
          beId: this.props.auth.erp.beId,
          code: this.props.orderName
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
  }

  postPOAPI = (params, data) => { 
    return axios.post(`${process.env.REACT_APP_API_URL}/api/erp/po`,{
      data:JSON.stringify(data)
    },{
        headers: {
            Authorization: 'Basic ' + this.props.auth.token
        },
        params:params
    });
  }

  getBranchIdAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/po/customer`, {
      params:{
        api: this.props.auth.erp.api.get.customer,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          menuCode: 'cus',
          beId: this.props.auth.erp.beId,
          code: this.props.branchCode
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
  }

  getProductsAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/po/product`, {
      params:{
        api: this.props.auth.erp.api.get.product,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          stSearch: 'proDualUnit',
          beId: this.props.auth.erp.beId,
          resultFields: 'proDualUnit.hId.pro.id;proDualUnit.hId.pro.code'
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
  }

  getInvoiceUnitsAPI = (head) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/erp/invoice/units`, {
      params:{
        api: this.props.auth.erp.api.get.product,
        headers:JSON.stringify(head),
        params:JSON.stringify({
          stSearch: 'proUnit',
          resultFields: 'proUnit.hId.pro.id;proUnit.hId.pro.code',
          beId: this.props.auth.erp.beId,
          conds:'proUnit.saleUnit=equal=1'
        })
      },
      headers: {
        'Authorization': `Basic ${this.props.auth.token}`,
      }
    })
  }

  putPushDate = (data) => {
    if(!data) {
      data = this.getDataPush(PUSH);
    }
    return axios.put(`${process.env.REACT_APP_API_URL}/api/erp/po/pushDate`,{
      id:data
    },{
      headers: {
          Authorization: 'Basic ' + this.props.auth.token
      }
    });
  }

// Deprecate this service with putERPSessionId
  putBusinessSessionId = (sessionId) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/erp/business/sessionId`,{},{
      headers: {
          Authorization: 'Basic ' + this.props.auth.token
      },
      params: {
        businessId:this.props.auth.businessId,
        sessionId:sessionId
      }
    });
  }


  putERPSessionId = (sessionId) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/erp/sessionId`,{},{
      headers: {
          Authorization: 'Basic ' + this.props.auth.token
      },
      params: {
        businessId:this.props.auth.businessId,
        supplierId:this.props.auth.supplierId,
        sessionId:sessionId,
        interval:24
      }
    });
  }

// DELETE SALES
  handleDeleteSales = async () => {
    switch(this.props.auth.erp.platform) {
      case MULTIABLE:{
        try {
          const sessionConfig = this.getSessionConfig();

          const head = {
            'client_id':sessionConfig.client_id,
            'authorization':`Bearer ${this.state.session}`
          };

          let res = await this.getPOIdAPI(head);
          if(res.data.data && res.data.data.id) {
            if(res.data.data.id > 0) {      
              
              const params = {
                erp:this.props.auth.erp.platform,
                api:this.props.auth.erp.api.delete.purchaseOrder,
                headers:head,
                params:{
                  menuCode: 'oldso',
                  beId: this.props.auth.erp.beId,
                  id: res.data.data.id
                }
              };
              
              axios.delete(`${process.env.REACT_APP_API_URL}/api/erp/po`,{
                headers: {
                    Authorization: 'Basic ' + this.props.auth.token
                },
                params:params
              });
            }
          }
        } catch (err) {
          this.handleError(err);
          return;
        }

        break;
      }
      default: {
        break;
      }
    }
  }

// DELETE INVOICE
  handleDeleteInvoice = async () => {
    switch(this.props.auth.erp.platform) {
      case MULTIABLE:{
        try {
          const sessionConfig = this.getSessionConfig();

          const head = {
            'client_id':sessionConfig.client_id,
            'authorization':`Bearer ${this.state.session}`
          };

          let response = await this.getInvoiceIdAPI(head);
          let res = response.data.data;

          if(res && res.values.length) {
            let invoiceId = res.values[0].id;
            if(invoiceId) {      
              const params = {
                erp:this.props.auth.erp.platform,
                api:this.props.auth.erp.api.delete.invoice,
                headers:head,
                params:{
                  menuCode: 'siso',
                  beId: this.props.auth.erp.beId,
                  id:invoiceId
                }
              };

              let response = this.deleteInvoiceAPI(params);
              this.handleDeleteInvoiceResponse(response);
            }
          }

        } catch (err) {
          this.handleCatch(err);
          return;
        }

        break;
      }
      default: {
        break;
      }
    }
  }

  handleDeleteInvoiceResponse = (response) => {
    if(response.info) {
      if(response.info.indexOf(MULTIABLE_ERROR_SESSION) > -1) {
        this.getSessionAPI({
          putERPSessionId:true
        });
      }
    }
  }

  // TRANSFER INVOICE DELIVERY LINE
  handleTransferLine = async () => {
    switch (this.props.auth.erp.platform) {
      case MULTIABLE: {
        try {
          const sessionConfig = this.getSessionConfig();

          const head = {
            'client_id': sessionConfig.client_id,
            'authorization': `Bearer ${this.state.session}`
          };

          const params = {
            erp: this.props.auth.erp.platform,
            api: this.props.auth.erp.api.put.invoice,
            headers: head,
            params: {
              menuCode: 'siso',
              beId: this.props.auth.erp.beId
            }
          };

          let response = await this.getInvoiceIdAPI(head);
          let res = response.data.data;

          if (res && res.values.length) {
            let invoiceId = res.values[0].id;

            this.setState({
              invoiceId: invoiceId
            }, () => {
              if (this.state.invoiceId) {
                (async () => {
                  try {
                    let response = await this.getInvoiceAPI(head);
                    let res = response.data.data

                    if (typeof res.maintar) {
                      let maintar = JSON.parse(res.maintar);

                      console.log("M18 REGION ID: ", DELIVERY_LINES[this.props.auth.supplierNum].filter((line) => line.id === this.props.deliveryLine)[0].m18id)
                      maintar.values[0].udfRegion = DELIVERY_LINES[this.props.auth.supplierNum].filter((line) => line.id === this.props.deliveryLine)[0].m18id;

                      res.maintar = JSON.stringify(maintar);
                    }
                    let response2 = await this.postInvoiceAPI(params, res);

                    console.log("handleTransferLine: ", response2)

                    this.handlePostInvoiceResponse(response2);
                  } catch (err) {
                    this.handleError(err);
                  }
                }
                )();
              }
            })
          }
        } catch (err) {
          this.handleCatch(err);
          return;
        }
        break;
      }
      default: {
        break;
      }
    }
  }

// Do Submit

  doSubmit = async () => {

    switch(this.props.auth.erp.platform) {
      case EASYSOFT:{
        let data = [{
          CreateDate:moment().format('YYYY-MM-DD'),
          OrderName:this.props.orderName,
          CusPORef:this.props.cusPORef,
          DeliveryDate:moment(this.props.deliveryDate).format('YYYY-MM-DD'),
          branchDetails: {
            "BranchName":this.props.branchName,
            "branchCode":this.props.branchCode
          },
          PORemark:this.props.remark,
          State:this.props.state,
          purchaseOrderItemList:this.props.data
        }];

        const params = {
          erp:this.props.auth.erp.platform,
          api:this.props.auth.erp.api.post,
          params: {
            bucketName:"lkhpo.agorahub.xyz",
            filenameField:"OrderName"
          }
        };

        try {
          this.postPOAPI(params, data);
          this.handleSuccess();
        } catch (err) {
          this.handleError(err);
        }
       break;
      }
      case ECOUNT:{
      function getADD_TXT_01_T(firstName, lastName, mobile){
        let contact = "";
        if(firstName && lastName) {
          contact= firstName + ' ' + lastName; 
        } else if(firstName && !lastName) {
          contact = firstName;
        }

        if(mobile) {
          return contact + " " + mobile;
        }

        return contact;
        }


      // ORDERED
      function getADDTXT02(isConvert, UnitIdWeigh, GoodsFormatName) {
        if(isConvert || UnitIdWeigh) {
          return GoodsFormatName;
        }
        return "";
      }

      function getUQTY(isConvert, UnitIdWeigh, Num) {
        if(isConvert || UnitIdWeigh) {
          return Num;
        }  
        return "";
      }

      // INVOICED
      function QTY(isConvert, UnitIdWeigh, Num, GoodsFormatNumber, WeighNum) {
        let qty = 0;
        if(isConvert) {
          qty = Num * GoodsFormatNumber;
        } else if(UnitIdWeigh) {
          qty = WeighNum;
        } else {
          qty = Num;
        }
        return qty.toFixed(5);
      }

      function PRICE(isConvert, UnitIdWeigh, salesPrice, GoodsFormatNumber) {
        let price = 0;
        if(isConvert) {
          price = salesPrice / GoodsFormatNumber;
        } else if(UnitIdWeigh) {
          price = salesPrice;
        } else {
          price = salesPrice;
        }
        return price.toFixed(2);
      }

      function SUPPLY_AMT(Num, WeighNum, salesPrice) {
        return Math.round((WeighNum ? WeighNum : Num) * salesPrice * 100) / 100;      
      }

      // get sessionId from agora DB
      let sessionId = "";
    
      try {
        let sessionConsole = await this.getSessionConsole();
        let expire = moment(moment(sessionConsole.ERPSessionExpiry).utc().format('YYYY-MM-DD HH:mm:ss')) < moment();
        if( expire ||  !sessionConsole.ERPSessionExpiry) {
          console.log('session expired');
          this.getSessionAPI({
            doSubmit:true
          });
          return;
        } else {
          console.log('existing session');
          sessionId = sessionConsole.ERPSessionId;
        }
      } catch (err) {
        this.handleError(err);
        return;
      }

      const params = {
        erp:this.props.auth.erp.platform,
        api:this.props.auth.erp.api.post,
        params: {
          "SESSION_ID":sessionId
        }
      };

      let saleList = [];
      let refPOId = [];
      let dataPush = this.getDataPush(PUSH);

        dataPush.forEach( (poId, index) => {
          let poi = this.getPOItems(poId);

          poi.forEach( (poi) => {
            refPOId.push(poId);
            const _QTY = QTY(poi.isConvert, poi.UnitIdWeigh, poi.Num, poi.GoodsFormatNumber, poi.WeighNum);
            if(_QTY > 0) {
              saleList.push({
                "BulkDatas": {
                    "UPLOAD_SER_NO": index + 1,
                    "IO_DATE": moment(this.getPOProperty(poId, 'StorageDate')).format('DDMMYYYY'), // po.StorageDate
                    "U_MEMO5": this.getPOProperty(poId, 'OrderName'), // po.OrderName
                    "CUST": this.getPOProperty(poId, 'BranchCode'), // b.BranchCode
                    "U_MEMO2": this.getPOProperty(poId, 'DepName'), // DepName
                    "ADD_TXT_02_T": this.getPOProperty(poId, 'Address'), // b.Address
                    "WH_CD": poi.GoodsRemark, // product.GoodsRemark
                    "U_MEMO1": "銷售", // 銷售
                    "U_TXT1": this.getPOProperty(poId, 'Remark'), // po.Remark
                    "ADD_DATE_01_T": moment(this.getPOProperty(poId, 'StorageDate')).format('DDMMYYYY'), // po.StorageDate
                    "ADD_TXT_01_T": getADD_TXT_01_T(this.getPOProperty(poId, 'FirstName'), this.getPOProperty(poId, 'LastName'), this.getPOProperty(poId, 'Mobile')), // o.FirstName + o.LastName, o.Mobile
                    "PROD_CD": poi.GoodsCode, // g.GoodsCode
                    "QTY": _QTY, // poi.Num, weighted qty (weighed), ordered qty * goodsFormatNum (converted)
                    "PRICE": PRICE(poi.isConvert, poi.UnitIdWeigh, poi.salesPrice, poi.GoodsFormatNumber), // poi.salesPrice, weighted unit price (weighed), salesPrice /GoodsFormatNum (converted)
                    "ADD_TXT_02":getADDTXT02(poi.isConvert, poi.UnitIdWeigh, poi.GoodsFormatName), // ordered unit
                    "UQTY":getUQTY(poi.isConvert, poi.UnitIdWeigh, poi.Num), // ordered qty
                    "SUPPLY_AMT": SUPPLY_AMT(poi.Num, poi.WeighNum, poi.salesPrice) // poi.Num * poi.salesPrice
                }
              });
            }

          });
        });

        //( async () =>  {
        try {
          let response = await this.postPOAPI(params, {
            "SaleList": saleList
          });

          let res = JSON.parse(response.data.data);
          if(res.Errors) {
            res.Errors.forEach((obj) => {
              if(obj["Code"] === "EXP00001" && !this.state.isLoading) {
                this.setState({
                  isSubmit:false,
                  authError:"ECOUNT authentication error, please try submitting again.",
                  isLoading:true
                }, () => {
                  this.getSessionAPI();
                });
              }
            })
          } else {
            if(typeof res.Data.FailCnt && res.Data.FailCnt > 0) {

              let errorMessage = "";
              let _dataPush = dataPush;
              let failIndex = [];
              
              res.Data.ResultDetails.forEach( (obj, index) => {

                if(!obj.IsSuccess) {
                  failIndex.push(index);
                }

                if(failIndex.length) {
                  failIndex.forEach( (index) => {
                    const i = _dataPush.indexOf(refPOId[index]);
                    if(i > -1) {
                      _dataPush.splice(i,1);
                    }
                  });
                }
                errorMessage = errorMessage+`${index+1}) ${obj.TotalError}<br />`;
              });

              this.setState({
                isSubmit:false,
                errorMessage:JSON.stringify(errorMessage)
              }, () => {
                if(_dataPush.length) {
                  this.putPushDate(_dataPush);
                }
              });
            } else {
              await this.putPushDate();
              this.handleSuccess();
            }
          }

        } catch (err) {
          this.handleError(err);
        }
        //})();

        break;
      }
      case MULTIABLE:{

        function formatOperatorName(name) {
          // manager@gdzlnm.com = Horus-manager
          let prefix = name.split('@')[0];
          return `Horus-${prefix}`;
        }

        const sessionConfig = this.getSessionConfig();

        const head = {
          'client_id':sessionConfig.client_id,
          'authorization':`Bearer ${this.state.session}`
        };

        if(this.props.auth.erp.mode === INVOICE) {
          /* 
          INVOICE
          */

         const params = {
          erp:this.props.auth.erp.platform,
          api:this.props.auth.erp.api.put.invoice,
          headers:head,
            params:{
              menuCode: 'siso',
              beId: this.props.auth.erp.beId
            }
          };

          ( async () =>  {
            try {
              let response = await axios.all([
                this.getInvoiceIdAPI(head), this.getBranchIdAPI(head), this.getProductsAPI(head), this.getInvoiceUnitsAPI(head)
              ]);

              let res = {};
              res["siso"] = response[0].data.data;
              res["cus"] = response[1].data.data;
              res["product"] = response[2].data.data;
              res["invoiceUnit"] = response[3].data.data;

              if(res["siso"] && typeof res["cus"].id) {
                let invoiceId = 0;
                let products = [];
                let invoiceUnits = [];

                if(res["siso"].values.length) {
                  invoiceId = res["siso"].values[0].id
                }
                
                if(res["product"].values) {
                  products = res["product"].values;
                }

                if(res["invoiceUnit"].values) {
                  invoiceUnits = res["invoiceUnit"].values;
                }

                if(!products.length || !invoiceUnits.length) {
                  this.handleError();
                  return;
                }

                this.setState({
                  invoiceId:invoiceId,
                  branchId:res["cus"].id,
                  products:products,
                  invoiceUnits:invoiceUnits
                }, () => {

                  if(this.state.invoiceId) {
                      // EXISTING PO
                      ( async () =>  {

                        try {
                          let response = await this.getInvoiceAPI(head);
                          let res = response.data.data;
                          
                          if(typeof res.maintar && typeof res.art) {

                            let maintar = JSON.parse(res.maintar);

                            // Horus user
                            maintar.values[0].udfhorususer = formatOperatorName(this.props.auth.operatorName);
                            
                            // customer PO reference
                            maintar.values[0].udfcuspono = this.props.cusPORef ? this.props.cusPORef : "";

                            // delivery date
                            maintar.values[0].tDate = moment(this.props.deliveryDate).format("YYYY-MM-DD 00:00:00");

                            // invoice date
                            //maintar.values[0].cpDate = moment(this.props.deliveryDate).add(1, 'days').format('YYYY-MM-DD 00:00:00')

                            // department
                            maintar.values[0].udfdepartment = this.props.depName ? this.props.depName : "";
                            
                            // delivery line
                            maintar.values[0].udfRegion = DELIVERY_LINES[this.props.auth.supplierNum].filter( (line) => line.id === this.props.deliveryLine )[0].m18id

                            let art = JSON.parse(res.art);
                            let data = JSON.parse(JSON.stringify(this.props.data));
                            let isDelete = false;

                            data.forEach((obj) => {
                              let filter = this.state.products.filter((product) => product["proDualUnit.hId.pro.code"] === obj.goodsCode && product["proDualUnit.unitId.unit.code"] === obj.goodsFormatName )[0];
                              if(filter) {
                                let index = art.values.findIndex( (item) => item.proId === filter["proDualUnit.hId.pro.id"] && item.dualUnitId === filter["id"]);
                                if(index > -1) {
                                  if(!parseInt(obj.num)) {
                                    isDelete = true;
                                  }
                                  art.values[index].dualQty = parseFloat(obj.num,2);
                                } else {

                                  // invoice unit
                                  let unitId = 0;
                                  let unitFilter = this.state.invoiceUnits.filter( (unit) => unit["proUnit.hId.pro.id"] === filter["proDualUnit.hId.pro.id"] )[0];
                                  if(unitFilter && unitFilter.id) {
                                    unitId = unitFilter.id;
                                  }
                                  
                                  if(parseInt(obj.num) > 0){
                                    art.values.push({
                                      "proId": filter["proDualUnit.hId.pro.id"],
                                      "qty":0,
                                      "unitId": unitId,
                                      "dualUnitId": filter.id,
                                      "dualQty": obj.num,
                                      "sourceType":"pro" 
                                    });
                                  }

                              }
                            }
                          });

                            art.values = art.values.filter( (row) => parseInt(row.dualQty) > 0 );

                            res.maintar = JSON.stringify(maintar);
                            res.art = JSON.stringify(art);

                            // only inlcude art, maintar in the payload to minimise packet size
                            //let payload = {
                            //  art:res.art,
                            //  maintar:res.maintar
                            //}
                                                      
                            if(isDelete) {    
                              params.api = this.props.auth.erp.api.delete.purchaseOrderItem;
                              let response = await this.postInvoiceAPI(params, res);
                              this.handlePostInvoiceResponse(response);
                            } else {
                              let response = await this.postInvoiceAPI(params, res);
                              this.handlePostInvoiceResponse(response);
                            }
                            
                            // TO-DO handle error state
                          } else {
                            this.handleError();
                          }  
                        } catch (err) {
                          this.handleError(err);
                        }
                      })();
                    
                  } else {
                      // NEW PO
                      ( async () =>  {
                        try {
                          console.log("M18 REGION ID: ", DELIVERY_LINES[this.props.auth.supplierNum].filter( (line) => line.id === this.props.deliveryLine )[0])
                          let maintarValues = [{
                            "flowTypeId": 10,
                            "udfhorussono": this.props.orderName,
                            "udfcuspono": this.props.cusPORef ? this.props.cusPORef : "",
                            "udfdepartment": this.props.depName ? this.props.depName : "",
                            "tDate": moment(this.props.deliveryDate).format("YYYY-MM-DD 00:00:00"),
                            "cpDate": moment(this.props.deliveryDate).add(1, 'days').format('YYYY-MM-DD 00:00:00'),
                            "udfhorususer": formatOperatorName(this.props.auth.operatorName),
                            "cusId": this.state.branchId,
                            "curId": 1,
                            "rate": 1.0,
                            "staffId": 4,
                            "beId": this.props.auth.erp.beId,
                            "udfRegion": DELIVERY_LINES[this.props.auth.supplierNum].filter( (line) => line.id === this.props.deliveryLine )[0].m18id
                          }];
                    
                          let artValues = [];

                          this.props.data.forEach( (obj) => {
                            let filter = this.state.products.filter((product) => product["proDualUnit.hId.pro.code"] === obj.goodsCode && product["proDualUnit.unitId.unit.code"] === obj.goodsFormatName )[0];
                            if(filter) {

                              // invoice unit
                              let unitId = 0;
                              let unitFilter = this.state.invoiceUnits.filter( (unit) => unit["proUnit.hId.pro.id"] === filter["proDualUnit.hId.pro.id"])[0];
                              if(unitFilter && unitFilter.id) {
                                unitId = unitFilter.id;
                              }

                              if(!unitId) {
                                this.handleError();
                              }

                              artValues.push({
                                "proId": filter["proDualUnit.hId.pro.id"],
                                "qty":0,
                                "unitId": unitId,
                                "dualUnitId": filter.id,
                                "dualQty": obj.num,
                                "sourceType":"pro" 
                              });

                            }
                          });
                    
                          let invoiceData = {
                            "maintar": {
                              "values": maintarValues
                            },
                            "art": {
                              "values": artValues
                            }
                          };

                          if(maintarValues.length && artValues) {
                            //console.log(invoiceData);
                            //return;
                            // temporarily override
                            //params.headers.authorization = "xxx";
                            let response = await this.postInvoiceAPI(params, invoiceData);
                            this.handlePostInvoiceResponse(response);

                          } else {
                            this.handleError();
                          }

                        } catch (err) {
                          this.handleError(err);
                        }
                      })();
                  }

                });

              } else {
                this.handleError();
              }

            } catch (err) {
              this.handleCatch(err);
            }
          })();

        } else {

            /*  
            SALES - NOT BEING USED
            */

          const params = {
            erp:this.props.auth.erp.platform,
            api:this.props.auth.erp.api.put.purchaseOrder,
            headers:head,
            params:{
              menuCode: 'oldso',
              beId: this.props.auth.erp.beId
            }
          };
              
          ( async () =>  {

          try {

            let response = await axios.all([
              this.getPOIdAPI(head), this.getBranchIdAPI(head), this.getProductsAPI(head)
            ]);

            let res = {};
            res["oldso"] = response[0].data.data;
            res["cus"] = response[1].data.data;
            res["product"] = response[2].data.data;

            if(typeof res["oldso"].id && typeof res["cus"].id) {
              this.setState({
                poId:res["oldso"].id,
                branchId:res["cus"].id,
                products:res["product"].values
              }, () => {

                    if(this.state.poId > 0) {
                      // EXISTING PO
                      ( async () =>  {

                        try {
                          let response = await this.getPOAPI(head);

                          let res = response.data.data;
                          
                          if(typeof res.mainso && typeof res.sot) {

                            let mainso = JSON.parse(res.mainso);
                            mainso.values[0].dDate = moment(this.props.deliveryDate).format('YYYY-MM-DD HH:mm:ss');
                            
                            let sot = JSON.parse(res.sot);
                            
                            /*
                            // TEST CASES
                
                            // change qty
                            //sot.values[0].qty = 45;
                            
                            // adding an item "OF00"
                            let obj = this.getProductByGoodsCodeGoodsFormatName('OF00', '包');
                            if(obj) {
                              let prodInsert = this.getProductInsert(obj);
                              sot.values.push(prodInsert);
                            }
                            */

                          let data = JSON.parse(JSON.stringify(this.props.data));

                          data.forEach((obj) => {
                            let filter = this.state.products.filter((product) => product["proUnit.hId.pro.code"] === obj.goodsCode && product["proUnit.unitId.unit.code"] === obj.goodsFormatName )[0];
                            if(filter) {
                              let index = sot.values.findIndex( (item) => item.proId === filter["proUnit.hId.pro.id"] && item.unitId === filter["id"]);
                              if(index > -1) {
                                  sot.values[index].qty = parseFloat(obj.num,2); 
                              } else {
                                sot.values.push({
                                  "proId": filter["proUnit.hId.pro.id"],
                                  "unitId": filter.id,
                                  "qty": obj.num
                                })
                              }
                            }
                          });

                            res.mainso = JSON.stringify(mainso);
                            res.sot = JSON.stringify(sot);
                          
                            await this.postPOAPI(params, res);
                            this.handleSuccess();

                            // TO-DO handle error state
                          } else {
                            this.handleError();
                          }  
                        } catch (err) {
                          this.handleError(err);
                        }
                      })();
                    } else {
                      // NEW PO
                      ( async () =>  {
                        try {

                          let mainsoValues = [{
                            "flowTypeId": 1,
                                "code": this.props.orderName,
                                "tDate": moment().format('YYYY-MM-DD HH:mm:ss'), //2022-02-22 22:22:22
                                "dDate":moment(this.props.deliveryDate).format('YYYY-MM-DD HH:mm:ss'),
                                "cusId": this.state.branchId,
                                "curId": 1,
                                "rate": 1.0,
                                "staffId": 4,
                                "beId": this.props.auth.erp.beId
                          }];
                    
                          let sotValues = [];
                          this.props.data.forEach( (obj) => {
                            let filter = this.state.products.filter((product) => product["proUnit.hId.pro.code"] === obj.goodsCode && product["proUnit.unitId.unit.code"] === obj.goodsFormatName )[0];
                            if(filter) {
                              sotValues.push({
                                "proId": filter["proUnit.hId.pro.id"],
                                "unitId": filter.id,
                                "qty": obj.num
                              });
                            }
                          });
                    
                          let poData = {
                            "mainso": {
                              "values": mainsoValues
                            },
                            "sot": {
                              "values": sotValues
                            }
                          };

                          if(mainsoValues.length && sotValues) {
                            await this.postPOAPI(params, poData);
                            this.handleSuccess();
                          } else {
                            this.handleError();
                          }

                        } catch (err) {
                          this.handleError(err);
                        }
                      })();
                    }
              });
            } else {
              this.handleError();
            }
          } catch (err) {
            this.handleError(err);
          }
          })();
        
        }

        break;
      }
      default: {
        // error
        this.handleError();
      }
  }
}

// Handle POST Invoice Response

  handlePostInvoiceResponse = (response) => {
    if(response.info) {
      if(response.info.indexOf(MULTIABLE_ERROR_SESSION) > -1) {
        this.getSessionAPI({
          putERPSessionId:true
        });
      } else {
        this.handleError();
      }
    } else {
      this.handleSuccess(response);
    }
  }

// Purchase Order Items

  getPurchaseOrdersItemsByPOId = () => {
    if(this.getDataPush(PUSH).length > 0) {
      axios.get(`${process.env.REACT_APP_API_URL}/api/getPurchaseOrdersItemsByPOId/`, 
      {
        params:{
          id:JSON.stringify(this.getDataPush(PUSH))
        },
        headers: {
          'Authorization': `Basic ${this.props.auth.token}`,
        }
      })
      .then( (response) => {
        //console.log('getPurchaseOrdersItemsByPOId',response.data.data);
        this.setState({
          dataPOI: response.data.data
        });
      })
      .catch( (err) => {
        this.handleError(err);
      });
    }
  }

  /*
  // Date Push (When push occured for the POs)

  datePushAPI = () => {
    axios.put(`${process.env.REACT_APP_API_URL}/api/erp/po/pushDate`,{
      id:JSON.stringify(this.getDataPush(PUSH))
    },{
        headers: {
            Authorization: 'Basic ' + this.props.auth.token
        }
    })
    .then( (response) => {
      this.setState({
        isSubmit:false,
        isSubmitSuccess:true
      });
    })
    .catch( (err) => {
      this.handleError(err);
    });
  }
  */

/*
Product
*/

getProductByGoodsCodeGoodsFormatName = (goodsCode, goodsFormatName) => {
  switch(this.props.auth.erp.platform) {
    case ECOUNT: {
    break;
    }
    case MULTIABLE: {
      let filter = this.state.products.filter((obj) => obj["proUnit.hId.pro.code"] === goodsCode && obj["proUnit.unitId.unit.code"] === goodsFormatName)[0];
      if(filter) {
        return filter;
      } else {
        return ""
      };
    }
    default: {
      // error
    }
  }
}

getProductInsert = (data) => {
  switch(this.props.auth.erp.platform) {
    case ECOUNT: {
      break;
    }
    case MULTIABLE: {
      return {
        "sourceType":"pro",
        "proId":data["proUnit.hId.pro.id"],
        "qty":100,
        "unitId":data["id"]
      }
    }
    default: {
      console.err("Error: ERP Platform not set")
    }
  }
}

/*
Modal
*/

  isDisabledSubmit = () => {
    if(this.state.isLoading || 
      this.state.errorMessage || 
      !this.getDataPush(PUSH).length) {
      return true;
    }
    return false;
  }

  handleSubmit = () => {
    this.setState({
      isSubmit:true
    }, () => {
      this.doSubmit();
    });
  }

  handleClose = () => {
    this.setState({
      errorMessage:'',
      authError:"",
      isLoading:false,
      isSubmit:false,
      isSubmitSuccess:false
    }, () => {
      this.props.handleClose();
    });
  }

/*
Purchase Orders
*/

  getPOProperty = (poId, property) => {
    if(this.props.data) {
      let po = this.props.data.filter( (obj) => obj.POId === poId )[0];
      if(po) {
        if(po[property]) {
          return po[property];
        }
        return "";
      }
    }
    return "";
  }

  getPOItems = (poId) => {
    let poi = this.state.dataPOI.filter( (obj) => obj.POId === poId );
    return poi;
  }

  getDataPush = (mode) => {
    let checked = this.props.poApprovedChecked.sort(
      (a,b) => {
          return moment(this.getPOProperty(b,'CreateDate')) - moment(this.getPOProperty(a,'CreateDate'));
    });
    checked = checked.filter( (po) => {
      if(mode === PUSH) {
        return !this.getPOProperty(po,'PushDate') ? true: false;
      } else if(mode === PUSHED) {
        return this.getPOProperty(po,'PushDate') ? true: false;
      }
    });

    return checked;
  }

/*
Loading
*/

  isLoading = () => {
    if(this.props.visible && !this.state.errorMessage) {
      if(this.state.isLoading) {
        return true;
      }
    }
    return false;
  }


/*
Render
*/

  noProductsFoundHTML = (mode) => {
    return (
      <div className="mb-4">
        <Alert className="bg-info text-white">
            <XCircle size={16} className="mb-1 mr-1" /> {mode === PUSH ? "No orders to push" : "No orders pushed"}
        </Alert>
      </div> 
    )
  }
  

  render() {
    if(!this.props.visible) {
      return <></>
    } else {
      return (
        <Modal 
          show={this.props.visible} 
          onHide={this.handleClose}
          size={"xl"}
          onShow={() => {
            this.getPurchaseOrdersItemsByPOId();
            //this.getSessionAPI();
          }}
        >
        <Modal.Header closeButton>
          <Modal.Title><I18N type={UI} path="PURCHASE_ORDERS" def="Purchase Orders"/> - <I18N type={UI} path="PUSH_TO_ERP" def="Push to ERP"/></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {
        this.state.errorMessage || this.state.authError || this.state.isLoading
        ?
        <>
            <AlertErrorComponent
              label={this.state.errorMessage ? this.state.errorMessage : this.state.authError}
            />
          { 
          this.isLoading() &&
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          }
        </>
        :
        <>
          {this.state.isSubmitSuccess &&
            <AlertSuccessComponent 
            label={<I18N type={UI} path="PURCHASE_ORDERS_SUCCESSFULLY_PUSHED" def="Purchase Orders Successfully Pushed!"/>} 
            />
          }

          <div className="mb-1">  
            <span className="font-weight-bold"><I18N type={UI} path="PUSH" def="Push"/></span>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th><I18N type={UI} path="ORDER_DATE" def="訂購日期"/></th>
              </tr>
            </thead>
            <tbody>
              {this.getDataPush(PUSH).map( (poId, index) => {
              return (
                <tr key={index}>
                  <td>{this.getPOProperty(poId,'OrderName')}</td>
                  <td>{moment(this.getPOProperty(poId,'CreateDate'),'').format('D MMM YYYY')}</td>
                </tr>
              )
              })}
            </tbody>
          </Table>
          {this.getDataPush(PUSH).length === 0 &&
            this.noProductsFoundHTML(PUSH)
          }
          
          {this.getDataPush(PUSHED).length > 0 &&
          <>
          <div className="mb-1">
            <span className="font-weight-bold"><I18N type={UI} path="PUSHED" def="Pushed"/></span>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th><I18N type={UI} path="ORDER_DATE" def="訂購日期"/></th>
              </tr>
            </thead>
            <tbody>
              {this.getDataPush(PUSHED).map( (poId) => {
              return (
                <tr>
                  <td>{this.getPOProperty(poId,'OrderName')}</td>
                  <td>{moment(this.getPOProperty(poId,'CreateDate'),'').format('D MMM YYYY')}</td>
                </tr>
              )
              })}
            </tbody>
          </Table>
          </>
          }
        </>
      }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            <I18N type={UI} path="CLOSE" def="Close"/>
          </Button>
          {!this.state.isSubmitSuccess &&
          <Button 
            variant="primary" 
            onClick={this.handleSubmit}
            disabled={this.isDisabledSubmit()}
            >
            {this.state.isSubmit ? <I18N type={UI} path="LOADING" def="Loading"/> : <I18N type={UI} path="SUBMIT" def="Submit"/>}
          </Button>}
        </Modal.Footer>
      </Modal>
      );
    }
  }
}

const mapStateToProps = state => {
  const {
      auth,
      poApprovedChecked
  } = state;

  return {
      auth: auth,
      poApprovedChecked: poApprovedChecked
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderERPComponent));